import { http } from 'vue'

export default {
  postUpload (context, params = {}) {
    return http.post('clients_pj_files', params.data)
  },
  putUpload (context, params = {}) {
    return http.put('clients_pj_files/' + params.data.id, params.data)
  },
  deleteUpload (context, params = {}) {
    return http.delete('clients_pj_files/' + params.id)
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/upload_client_pj_file/actions.js